import { IAppState } from '../state/app.state';
import { createSelector } from '@ngrx/store';
import { IPage } from 'src/app/models/page.interface';
import { IPageState } from '../state/page.state';

const pageState = (state: IAppState) => state.page;

export const selectLoading = createSelector(pageState, (state: IPageState) => state.page.loading);

export const selectLoadingMenu = createSelector(
  pageState,
  (state: IPageState) => state.page.loadingMenu
);

export const selectPlace = createSelector(
  pageState,
  (state: IPageState) => state.page.placeSelected
);

export const selectFullScreen = createSelector(
  pageState,
  (state: IPageState) => state.page.fullScreen
);

export const selectShowMenu = createSelector(pageState, (state: IPageState) => state.page.showMenu);

export const selectShowCart = createSelector(pageState, (state: IPageState) => state.page.showCart);
export const selectShowLast = createSelector(pageState, (state: IPageState) => state.page.showLast);
export const selectShowBonus = createSelector(pageState, (state: IPageState) => state.page.showBonus);

export const selectSession = createSelector(pageState, (state: IPageState) => state.page.session);
export const selectCID = createSelector(pageState, (state: IPageState) => state.page.cid);

export const selectFirstStreaming = createSelector(
  pageState,
  (state: IPageState) => state.page.firstStreaming
);

export const selectPlayerRace = createSelector(
  pageState,
  (state: IPageState) => state.page.playerRace
);

export const selectIp = createSelector(pageState, (state: IPageState) => state.page.ip);

export const selectLogo = createSelector(pageState, (state: IPageState) => state.page.urllogo);

export const selectImagesHome = createSelector(
  pageState,
  (state: IPageState) => state.page.imageshome
);

export const selectImagesCart = createSelector(
  pageState,
  (state: IPageState) => state.page.imagescart
);

export const selectTrackGA = createSelector(pageState, (state: IPageState) => state.page.trackGA);

export const selectVideoEnabled = createSelector(
  pageState,
  (state: IPageState) => state.page.videoEnabled
);

export const selectPlayVideo = createSelector(
  pageState,
  (state: IPageState) => state.page.playVideo
);

export const selectDisableAudio = createSelector(
  pageState,
  (state: IPageState) => state.page.disableaudio
);

export const selectShowTicketList = createSelector(
  pageState,
  (state: IPageState) => state.page.showTicketList
);

export const selectFunctionCompleteBet = createSelector(
  pageState,
  (state: IPageState) => state.page.functionCompleteBet
);

export const selectFunctionButtonBet = createSelector(
  pageState,
  (state: IPageState) => state.page.functionButtonBet
);

export const selectTabCartIndex = createSelector(
  pageState,
  (state: IPageState) => state.page.cartTabIndex
);

export const selectTabMenuIndex = createSelector(
  pageState,
  (state: IPageState) => state.page.menuTabIndex
);

export const selectCountryMenu = createSelector(
  pageState,
  (state: IPageState) => state.page.countryMenu
);

export const selectTypeMenu = createSelector(
  pageState,
  (state: IPageState) => state.page.typeMenu
);
export const selectSystemBetMenu = createSelector(
  pageState,
  (state: IPageState) => state.page.systemBetMenu
);

export const selectOpenRace = createSelector(
    pageState,
    (state: IPageState) => state.page.openRace
);

export const selectOpenNoOddRace = createSelector(
    pageState,
    (state: IPageState) => state.page.openNoOddRace
);

export const selectCloseRace = createSelector(
    pageState,
    (state: IPageState) => state.page.closeRace
);

export const selectFreebetSingle = createSelector(
  pageState,
  (state: IPageState) => state.page.freebetSingle
);

export const selectFreebetMultiple = createSelector(
  pageState,
  (state: IPageState) => state.page.freebetMultiple
);

export const selectFreebetSystem = createSelector(
  pageState,
  (state: IPageState) => state.page.freebetSystem
);

export const selectBonusSingle = createSelector(
  pageState,
  (state: IPageState) => state.page.bonusSingle
);

export const selectBonusMultiple = createSelector(
  pageState,
  (state: IPageState) => state.page.bonusMultiple
);

export const selectBonusSystem = createSelector(
  pageState,
  (state: IPageState) => state.page.bonusSystem
);

export const selectCount = createSelector(
    pageState,
    (state: IPageState) => state.page.count
);

export const selectReminder = createSelector(
    pageState,
    (state: IPageState) => state.page.reminder
);

export const selectFavorites = createSelector(
    pageState,
    (state: IPageState) => state.page.favorites
);

export const selectHidefullstats = createSelector(
    pageState,
    (state: IPageState) => state.page.hidefullstats
);

export const selectTerminalTag = createSelector(
    pageState,
    (state: IPageState) => state.page.terminalTag
);

export const selectErrorPage = createSelector(
    pageState,
    (state: IPageState) => state.page.errorPage
);

export const selectConfirmBetState = createSelector(
    pageState,
    (state: IPageState) => state.page.confirmBetState
);

export const selectCoverVideo = createSelector(
    pageState,
    (state: IPageState) => state.page.coverVideo
);

export const selectToday = createSelector(
    pageState,
    (state: IPageState) => state.page.today
);

